module.exports = __webpack_public_path__ + "static/media/foto1.8850e777.jpeg";